export interface APITournament {
  id: number;
  name: string;
  size: number;
  tournament_type: string;
  status: 'started' | 'ended' | 'created' | 'draft' | 'start' | ''| 'demo';
  current_round: number;
  total_rounds: number;
  match_time: number;
  match_ends: number;
  position_set: APIPosition[];
  views: number;
  champion?: APIPosition;
}

export interface APIPosition {
  id: number;
  bracket_index: number;
  depth: number;
  votes: number;
  player?: APIPlayer;
  next_position: number | undefined;
  left_position: number | undefined;
  right_position: number | undefined;
}

export interface APIPlayer {
  id: number;
  avatar: string;
  name: string;
}

export const defaultPlayer: APIPlayer = {
  id: -1,
  avatar:
    'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
  name: '',
};